import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useAuthContext, useVisitContext } from '@hooks';
import LoadingSpinner from '@components/LoadingSpinner';
import { purposesLoadingSpinner } from '@constants';

const VerifyEmailScreen = () => {
  const history = useHistory();
  const { email, token } = useParams();

  const { verifyEmailWithCode } = useAuthContext();
  const { createVisit } = useVisitContext();
  const stringifyPlaceData = localStorage.getItem('place');

  const goToNextScreen = async () => {
    const parsedPlaceData = JSON.parse(stringifyPlaceData);

    await createVisit({
      placeId: parsedPlaceData.placeId,
      tableId: parsedPlaceData.tableId,
    });

    history.push(
      `/visit/${parsedPlaceData.placeId}/${parsedPlaceData.tableId}`,
    );
  };

  const sendVerifyCode = async (email, code) => {
    const res = await verifyEmailWithCode({ email, code });
    if (!res) return false;
    await goToNextScreen();
  };

  useEffect(() => {
    sendVerifyCode(email, token, goToNextScreen);
    // eslint-disable-next-line
  }, []);

  return <LoadingSpinner purpose={purposesLoadingSpinner.additional} />;
};

export default VerifyEmailScreen;
